import request from '../utils/Request';
import { Methods } from '../config';

const syncService = {
  syncMnbExchangeRates: () => {
    return request({
      method: Methods.POST,
      resource: `sync/mnb/sync`,
    });
  },
};
export default syncService;
